import { Container } from "./styles";

export function Spinner() {
    return (
        <Container>
            <div></div>
            <div></div>
        </Container>
    )
}